//React and Hooks
import React, { useState, useEffect, useRef } from "react";
import useAxios from "../../hooks/useAxios";

//Components
import SearchForm from "./partial/SearchForm";
import CommonList from "../common/CommonList";
import ListData from "./partial/ListData";

//Utilities and Interfaces
import useCommonActions from "../../hooks/useCommonActions";
import { NewsLetterEmailSearchFormState, NewsLetterEmail } from "../../types/interfaces";

const List: React.FC = () => {
  const axiosInstance = useAxios();
  const { changeItemStatus, deleteItem } = useCommonActions();
  const [searchForm, setSearchForm] = useState<NewsLetterEmailSearchFormState>({
    search_string: "",
    status: "",
    is_verified: "",
  });
  const [results, setResults] = useState<NewsLetterEmail[] | null>(null);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const [isLoading, setIsLoading] = useState(false);
  const isInitialRender = useRef(false);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    getListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  /*Handle pagination data change*/
  const handlePageChange = (page: number, pageSize: number) => {
    setPagination({ currentPage: page, pageSize });
  };

  const getListData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const response: any = await axiosInstance({
        url: "news-letter/list",
        method: "GET",
        data: {
          page: pagination.currentPage,
          limit: pagination.pageSize,
          search_string: searchForm.search_string,
          status: searchForm.status,
          is_verified: searchForm.is_verified,
        },
      });
      // console.log("settings list response", response);
      setResults(response.data.emaillists.docs);
      setTotalItems(response.data.emaillists.totalDocs);
    } catch (error: any) {
      console.error("Error in api request:", error);
    } finally {
      setTimeout(() => setIsLoading(false), 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, searchForm]);

  /*Change selected item status*/
  const changeEmailStatus = async (itemid?: string, status?: number) => {
    const newStatus = status === 1 ? 0 : 1;
    const message = `Are you sure you want to ${
      status === 1 ? "unverify" : "verify"
    } the Email?`;
    changeItemStatus(
      itemid,
      newStatus,
      "news-letter/update-verification-status",
      message,
      getListData
    );
  };

  /*Delete selected item*/
  const deleteEmail = async (itemid?: string) => {
    const message = `Are you sure you want to delete the Email?`;
    deleteItem(`news-letter/delete/${itemid}`, message, getListData);
  };

  return (
    <CommonList<NewsLetterEmail>
      title="News Letter Email List"
      listData={
        <MemoizedListData
          isLoading={isLoading}
          results={results}
          getListData={getListData}
          changeEmailStatus={changeEmailStatus}
          deleteEmail={deleteEmail}
        />
      }
      searchForm={
        <MemoizedSearchForm
          searchForm={searchForm}
          setSearchForm={setSearchForm}
          handleSearchClick={getListData}
        />
      }
      isLoading={isLoading}
      results={results}
      totalItems={totalItems}
      pageSize={pagination.pageSize}
      handlePageChange={handlePageChange}
	  searchFormExist = {true}
    />
  );
};

const MemoizedListData = React.memo(ListData);
const MemoizedSearchForm = React.memo(SearchForm);

export default List;
